import { Component, OnInit } from '@angular/core';
import { AppStateService } from './modules/common/services/app-state/app-state.service';
import { ThemeService } from './modules/common/services/theme/theme.service';
import { UpgradeModule } from '@angular/upgrade/static';
import { RouteInterceptorService } from './modules/common/services/route-interceptor/route-interceptor.service';
import { BannerService } from './modules/common/services/banner/banner.service';
import { BannerMessage } from './modules/common/services/banner/banner-message';
import { FavoritesInstructionMessageComponent } from './modules/common/components/banner/messages/favorites-instruction-message.component';
import { Router } from '@angular/router';

@Component({
    selector: 'cas-root',
    templateUrl: './cas.component.html',
    styleUrls: ['./cas.component.scss']
})
export class CasComponent implements OnInit {
    constructor(
        public appStateService: AppStateService,
        themeService: ThemeService,
        upgrade: UpgradeModule,
        routeInterceptorService: RouteInterceptorService,
        private bannerService: BannerService,
        private router: Router
    ) {
    }

    public ngOnInit() {
        this.bannerService.openBanner(new BannerMessage(FavoritesInstructionMessageComponent,
            'DISMISS',
            'LEARN MORE',
            () => {
                this.router.navigateByUrl(`help/tutorials/how-to-use-favorite`);
            },
            'star',
            null,
            null,
            -1,
            null,
            false,
            true
        ), 3000);
    }
}
